// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__UkwHp","selects":"Documents_selects__3Akq6"};